import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import apiClient from './api';
import moment from 'jalali-moment';
import {
    Container, Grid, Card, CardContent, Typography, Box, Chip, Button,
    CircularProgress, Paper
} from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import DescriptionIcon from '@mui/icons-material/Description';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { formatToman } from './labels';

function MyBids() {
    const [myBids, setMyBids] = useState([]);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState('');

    useEffect(() => {
        const fetchMyBids = async () => {
            try {
                const response = await apiClient.get('/api/my-bids/');
                setMyBids(response.data);
            } catch (error) {
                setMessage('خطا در دریافت لیست پیشنهادها.');
                console.error('Failed to fetch my bids', error);
            } finally {
                setLoading(false);
            }
        };
        fetchMyBids();
    }, []);

    const getStatusChip = (status) => {
        if (status === 'submitted') return <Chip label="ارسال شده" color="info" variant="outlined" />;
        if (status === 'accepted') return <Chip label="پذیرفته شده" color="success" />;
        if (status === 'rejected') return <Chip label="رد شده" color="error" variant="outlined" />;
        return <Chip label={status} />;
    };

    if (loading) {
        return <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}><CircularProgress /></Box>;
    }

    return (
        <Container maxWidth="lg" sx={{ mt: 4 }}>
            <Button component={RouterLink} to="/dashboard" startIcon={<ArrowForwardIcon />} size="small" sx={{ mb: 1, color: 'text.secondary' }}>
                بازگشت به داشبورد
            </Button>
            <Typography variant="h4" component="h1" gutterBottom sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                پیشنهادهای من
            </Typography>
            {message && <Typography color="error" sx={{ textAlign: 'center', mb: 2 }}>{message}</Typography>}
            
            <Grid container spacing={3} justifyContent="center">
                {myBids.length > 0 ? (
                    myBids.map(bid => (
                        <Grid item xs={12} md={8} key={bid.id}>
                            <Card elevation={2} sx={{ borderRadius: 2 }}>
                                <CardContent>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                        <Typography variant="h6" component="h2">
                                            پیشنهاد برای درخواست #{bid.request.id}
                                        </Typography>
                                        {getStatusChip(bid.status)}
                                    </Box>
                                    <Typography color="text.secondary">
                                        تاریخ درخواست: {moment(bid.request.start_date).locale('fa').format('YYYY/MM/DD')}
                                    </Typography>
                                    <Typography color="text.secondary" sx={{ mt: 1 }}>
                                        وضعیت کلی درخواست: {bid.request.status}
                                    </Typography>
                                    {bid.amount ? (
                                        <Typography sx={{ mt: 1, fontWeight: 700 }}>
                                            نرخ پیشنهادی شما: {formatToman(bid.amount)}
                                        </Typography>
                                    ) : null}
                                    {bid.status === 'accepted' && (
                                        <Button
                                            size="small" variant="outlined" startIcon={<DescriptionIcon />}
                                            component={RouterLink} to={`/contracts/${bid.request.id}`}
                                            sx={{ mt: 1.5 }}
                                        >
                                            مشاهده و پذیرش قرارداد
                                        </Button>
                                    )}
                                </CardContent>
                            </Card>
                        </Grid>
                    ))
                ) : (
                    <Paper sx={{ p: 4, textAlign: 'center', width: '100%' }}>
                        <HistoryIcon sx={{ fontSize: 60, color: 'grey.400' }} />
                        <Typography variant="h6" sx={{ mt: 2 }}>
                            شما هنوز هیچ پیشنهادی ثبت نکرده‌اید.
                        </Typography>
                        <Typography color="text.secondary">
                            به بخش "درخواست‌های جدید" بروید تا اولین پیشنهاد خود را ثبت کنید.
                        </Typography>
                    </Paper>
                )}
            </Grid>
        </Container>
    );
}

export default MyBids;

